import type { TemplateParam } from '@/components/WellLoggingOperations/types';

/*
    Функция временно убирает дублирующие колонки.
    
    Такие колонки появляются из за того, что у колонок есть вложенные данные, который сейчас представлены в плоской структуре.
    Необходима группировка таких данных.

    TODO: Когда backend сделает это, нужно удалить эту функцию.
*/
const fastFormat = (params: TemplateParam[]) => {
    const result = [] as TemplateParam[];
    const indexes: number[] = [];

    for (const param of params) {
        if (indexes.includes(param.paramColumn)) continue;

        result.push(param);
        indexes.push(param.paramColumn);
    }

    return result;
};

interface ColumnsProps {
    data: TemplateParam[];
}

export const Columns = (props: ColumnsProps) => {
    const { data } = props;

    return (
        <div className="h-full overflow-y-auto p-4 text-xs">
            <div className="mb-3 text-xxs uppercase">Колонки</div>
            <ul>
                {fastFormat(data).map((param, idx) => {
                    const { children } = param;
                    return (
                        <li key={idx} className="py-[1px]">
                            <span className="truncate text-xs text-black dark:text-white">
                                {idx + 1} {param.paramTitle}
                            </span>
                            {children ? (
                                <ul className="pl-3">
                                    {children.map((child, idx) => {
                                        return (
                                            <li key={idx} className="truncate text-xs text-black dark:text-white">
                                                {child.strParamValue}
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : null}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
